module.exports = __webpack_public_path__ + "img/docx.a2269a7c.png";